import { ChangePassword, ChangeProfile } from '@components';
import { LogApp } from '@utils';
import { ChangeEvent, useCallback, useEffect, useRef, useState } from 'react';

export const ChangePasswordModule = () => {
  return <ChangePassword />;
};
